import React from 'react';
import PropTypes from 'prop-types';

const SVG = ({color = '#2F343B', width = 'auto', height = 'auto', className = ''}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>back-arrow-16px</title>

    <g id="mweb-final" stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
      <g id="iphone-8---updated-header" transform="translate(-8.000000, -88.000000)" fill={color}>
        <g id="Group-13" transform="translate(0.000000, 70.000000)">
          <polygon id="Shape" points="24 25 11.8 25 17.4 19.4 16 18 8 26 16 34 17.4 32.6 11.8 27 24 27" />
        </g>
      </g>
    </g>
  </svg>
);

SVG.propTypes = {
  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,

  /**
   * Color hex code
   */
  color: PropTypes.string,

  /**
   * Icon width
   */
  width: PropTypes.string,

  /**
   * Icon height
   */
  height: PropTypes.string,
};

export default SVG;
